import template from './text.html';
import controller from './text.controller';
import './text.scss';

let textComponent = {
  bindings: {
    article: '<'
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default textComponent;



// WEBPACK FOOTER //
// ./client/app/components/content-types/text/text.component.js